import React from 'react'

const AboutIconThree = () => {
    return (
        <img src="https://img.icons8.com/ios-filled/50/000000/training.png" alt="Experienced Trainer" style={{ width: '50px', height: '50px' }} />
    )
}

export default AboutIconThree